var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-page-wrapper"},[_c('p-routed-tabs',{staticClass:"pt-1",attrs:{"tabs":_vm.tabs}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }